export const APNS_TYPE_PROD = "APNS_PROD";
export const APNS_TYPE_DEV = "APNS_DEV";
export const APNS_TYPE_ALL = "APNS_ALL";

const PROD_CERT_NAME = "PowerMaxCert.pem";
const PROD_KEY_NAME = "PowerMaxKey.pem";
const DEV_CERT_NAME = "PowerMaxSandboxCert.pem";
const DEV_KEY_NAME = "PowerMaxSandboxKey.pem";

export const APNS_NAME_MAP = {
  [APNS_TYPE_PROD]: [PROD_CERT_NAME, PROD_KEY_NAME],
  [APNS_TYPE_DEV]: [DEV_CERT_NAME, DEV_KEY_NAME],
};

export const APNS = "APNS";
export const FCM = "FCM";
